import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useAppSelector } from "src/store";
import { getCurrencies } from "src/store/system/saga";
import { CurrencyDto } from "src/store/system/type";
import { createPackageSaga } from "src/store/web-packages/saga";
import * as Yup from "yup";
import PackageDrawer from "./PackageDrawer";

const PackageCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [currencies, setCurrencies] = useState<CurrencyDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getCurrencies({
          payload: {
            onSuccess: (m, p) => setCurrencies(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);

  return (
    <PackageDrawer
      open={open}
      onHide={onHide}
      title={t("Package.CreateFormTitle").toString()}
      submitLabel={t("FormComponent.Save").toString()}
      currencies={currencies}
      initialValues={{
        Translates: languages.map((x) => {
          return { LanguageId: x.EnumId, Name: "" };
        }),
        AssetLimit: "",
        UserLimit: "",
        MailboxLimit: "",
        StorageLimit: "",
        AssetFeatureCount: "",
        Location: "",
        ListPriceMonthly: "",
        CampaignPriceMonthly: "",
        ListPriceYearly: "",
        CampaignPriceYearly: "",
        CampaignEndDate: "",
        CurrencyId: "",
        Management: false,
        MobileApp: false,
        WebSite: false,
        APIIO: false,
        UygunaKirala: false,
        Booqapp: false,
        Freemium: false,
        ShowWeb: false,
        Order: 1,
        ParentId: "",
        Maintenance: false,
        FinancialAccounts: false,
        ExtraServices: false,
        Expenses: false,
        Insurances: false,
        Suppliers: false,
      }}
      validationSchema={Yup.object().shape({
        Translates: Yup.array(
          Yup.object({
            Name: Yup.string().required(t("Validation.Required").toString()),
          })
        ),
        CurrencyId: Yup.number().required(t("Validation.Required").toString()),
        AssetLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        UserLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        MailboxLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        StorageLimit: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        Location: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        CampaignPriceMonthly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        ListPriceMonthly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        CampaignPriceYearly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        ListPriceYearly: Yup.number()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
        CampaignEndDate: Yup.string()
          .typeError(t("Validation.Required").toString())
          .required(t("Validation.Required").toString()),
      })}
      onSubmit={(values) => {
        dispatch(
          createPackageSaga({
            payload: {
              onSuccess: (message, payload) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => {
                toast.error(message, { theme: "colored" });
              },
            },
            body: values,
          })
        );
      }}
    />
  );
};
export default PackageCreateForm;
